/**
 * Client API pour les consentements utilisateur
 */
import { HttpClient } from '@sphere/shared/data-access/http';
import type {
  UserConsent,
  GrantConsentDto,
  ConsentCheckResult,
  ListConsentsDto,
  ConsentKind,
} from '@sphere/user/domain';

const BASE_PATH = '/consents';

export const consentsClient = {
  /**
   * Récupère tous les consentements
   */
  async getAll(filters?: ListConsentsDto): Promise<UserConsent[]> {
    const { data } = await HttpClient.get<UserConsent[]>(BASE_PATH, {
      params: filters,
    });
    return data;
  },

  /**
   * Vérifie si un consentement est accordé
   */
  async check(
    kind: ConsentKind,
    version?: string
  ): Promise<ConsentCheckResult> {
    const params = version ? { version } : undefined;
    const { data } = await HttpClient.get<ConsentCheckResult>(
      `${BASE_PATH}/check/${kind}`,
      { params }
    );
    return data;
  },

  /**
   * Récupère l'historique des consentements pour un type
   */
  async getHistory(kind: ConsentKind): Promise<UserConsent[]> {
    const { data } = await HttpClient.get<UserConsent[]>(
      `${BASE_PATH}/history/${kind}`
    );
    return data;
  },

  /**
   * Accorde ou refuse un consentement
   */
  async grant(dto: GrantConsentDto): Promise<UserConsent> {
    const { data } = await HttpClient.post<UserConsent>(BASE_PATH, {
      ...dto,
      ipAddress: dto.ipAddress || window.location.hostname,
      userAgent: dto.userAgent || navigator.userAgent,
      localeAtSign: dto.localeAtSign || navigator.language,
    });
    return data;
  },

  /**
   * Retire un consentement
   */
  async withdraw(kind: ConsentKind, version: string): Promise<UserConsent> {
    const { data } = await HttpClient.post<UserConsent>(
      `${BASE_PATH}/withdraw/${kind}/${version}`
    );
    return data;
  },

  /**
   * Supprime tous les consentements (RGPD)
   */
  async deleteAll(): Promise<{ count: number }> {
    const { data } = await HttpClient.delete<{ count: number }>(BASE_PATH);
    return data;
  },
};
